import { HOME_PATH, PROFESSIONS_PATH, SCHOOLS_PATH, SEARCH_PATH, USERS_PATH } from "../constants/RoutesConstants";

import AllProfessions from "../layout/pages/Profession/All";
import AllSchools from "../layout/pages/School/All";
import AllUsers from "../layout/pages/User/All";
import Home from "../layout/pages/Home";
import NewProfession from "../layout/pages/Profession/New";
import NewSchool from "../layout/pages/School/New";
import NewUser from "../layout/pages/User/New";
import Profession from "../layout/pages/Profession/Single";
import React from "react";
import { Redirect } from "react-router";
import { Route } from "react-router-dom";
import School from "../layout/pages/School/Single";
import Search from "../layout/pages/Search";
import User from "../layout/pages/User/Single";
import getIdSelector from "../state/selectors/ClientSelectors/getIdSelector";
import renderComponent from "./renderComponent";
import { useSelector } from "react-redux";

const routes = {
    Home: {
        exact: true,
        strict: false,
        path: HOME_PATH,
        title: "Home",
        renderer: {
            component: Home
        }
    },
    AllProfessions: {
        exact: true,
        strict: false,
        path: PROFESSIONS_PATH,
        title: "Profili Professionali",
        renderer: {
            component: AllProfessions
        }
    },
    Profession: {
        exact: true,
        strict: false,
        path: `${PROFESSIONS_PATH}/:slug/:id`,
        title: "",
        renderer: {
            component: Profession
        }
    },
    NewProfession: {
        exact: true,
        strict: false,
        path: `${PROFESSIONS_PATH}/new`,
        title: "Nuovo profilo professionale",
        renderer: {
            component: NewProfession
        }
    },
    AllSchools: {
        exact: true,
        strict: false,
        path: SCHOOLS_PATH,
        title: "Informativa",
        renderer: {
            component: AllSchools
        }
    },
    School: {
        exact: true,
        strict: false,
        path: `${SCHOOLS_PATH}/:slug/:id`,
        title: "",
        renderer: {
            component: School
        }
    },
    NewSchool: {
        exact: true,
        strict: false,
        path: `${SCHOOLS_PATH}/new`,
        title: "Nuova informativa",
        renderer: {
            component: NewSchool
        }
    },
    AllUsers: {
        exact: true,
        strict: false,
        path: USERS_PATH,
        title: "Utenti",
        renderer: {
            component: AllUsers
        }
    },
    User: {
        exact: true,
        strict: false,
        path: `${USERS_PATH}/:slug-:id`,
        title: "",
        renderer: {
            component: User
        }
    },
    NewUser: {
        exact: true,
        strict: false,
        path: `${USERS_PATH}/new`,
        title: "Nuovo utente",
        renderer: {
            component: NewUser
        }
    },
    Search: {
        exact: true,
        strict: false,
        path: SEARCH_PATH,
        title: "",
        renderer: {
            component: Search
        }
    }
};

export default function() {
    const isUserLoggedIn = useSelector((state: Store) => getIdSelector(state));
    return (
        <>
            {Object.values(routes).map((route, i) => {
                return (
                    <Route
                        key={`route-${i}`}
                        exact={route.exact}
                        strict={route.strict}
                        path={route.path}
                        render={(props: React.Props<any> | GenericObject) => {
                            if (!isUserLoggedIn && route.path !== HOME_PATH) {
                                return <Redirect to={HOME_PATH} />;
                            }
                            return renderComponent(route.renderer, { ...props, title: route.title });
                        }}
                    />
                );
            })}
        </>
    );
}
